<template>
  <BaseScreen v-bind="screen">
    <div class="screen__wait" slot="middle">
      <Quantity
        v-if="quantity"
        v-bind="quantity"
        @decrease="decreaseQuantity"
        @increase="increaseQuantity"
      />
      <div class="screen__gap screen__gap_half">
        <BaseText
          v-if="price"
          v-bind="price"
        />
      </div>
      <div class="screen__gap screen__gap_double">
        <BaseButton
          v-bind="payButton"
          @click="goToPayScreen"
        />
      </div>
    </div>
  </BaseScreen>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { GLOBAL_EVENTS } from '@/App.vue';

import screenMixin from '@/mixins/screen';

import Quantity from '@/components/Quantity.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseText from '@/components/BaseText.vue';

const MIN_QUANTITY = 1;
const MAX_QUANTITY = 30;

export default {
  name: 'TicketsCountScreen',
  mixins: [screenMixin],
  components: {
    Quantity,
    BaseButton,
    BaseText,
  },
  computed: {
    ...mapState('tickets', [
      'count',
    ]),
    ...mapGetters('tickets', [
      'sum',
    ]),
    titleText() {
      return this.$t('tickets.countTitle');
    },
    screenCase() {
      return 'STEP_TICKETS_COUNT';
    },
    quantity() {
      return {
        value: this.count,
        min: MIN_QUANTITY,
        max: MAX_QUANTITY,
      };
    },
    price() {
      const sum = this.$options.filters.sum(this.sum);
      return {
        text: this.$t('tickets.sum', { sum }),
        size: 'xl',
      };
    },
    payButton() {
      return {
        text: this.$t('tickets.pay'),
      };
    },
  },
  created() {
    this.initActions([
      ['ACTION_GO_PAY', this.goToPayScreen],
      ['ACTION_DECREASE_QUANTITY', this.decreaseQuantity],
      ['ACTION_INCREASE_QUANTITY', this.increaseQuantity],
      [GLOBAL_EVENTS.USER_REPLIC_FINISH, this.onUserReplic],
    ]);
  },
  methods: {
    ...mapMutations('tickets', [
      'setCount',
    ]),
    decreaseQuantity() {
      this.setQuantity(this.count - 1);
    },
    increaseQuantity() {
      this.setQuantity(this.count + 1);
    },
    setQuantity(value) {
      let quantity = Math.ceil(value) || this.count;
      quantity = quantity >= MAX_QUANTITY ? MAX_QUANTITY : quantity;
      quantity = quantity <= MIN_QUANTITY ? MIN_QUANTITY : quantity;
      this.setCount(quantity);
    },
    onUserReplic(replic) {
      const searchWord = this.$t('tickets.searchWord');
      const regex = new RegExp(`([.\\d]+)\\s?(${searchWord})?`);
      const [, count] = replic.match(regex) || [];
      if (count) {
        this.setQuantity(count);
      }
    },
    goToPayScreen() {
      this.$router.push(this.$router.options.paths.pay);
    },
  },
};
</script>
